import { render, staticRenderFns } from "./PurchaseOrdersForm.vue?vue&type=template&id=4ac8f6c7&scoped=true&"
import script from "./PurchaseOrdersForm.vue?vue&type=script&lang=js&"
export * from "./PurchaseOrdersForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ac8f6c7",
  null
  
)

export default component.exports